import React from 'react';

import Spinner from '@atlaskit/spinner/spinner';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Pressable } from '@atlaskit/primitives/compiled/pressable';
import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

import { expValEquals } from '@confluence/feature-experiments';

const showMoreStyles = cssMap({
	button: {
		backgroundColor: 'transparent',
		border: 'none',
		padding: token('space.0'),
		cursor: 'pointer',
	},
	showMoreLink: {
		font: token('font.body.large'),
		color: token('color.link'),
		textTransform: 'capitalize',
		textDecoration: 'none',
		display: 'flex',
		alignItems: 'center',
		gap: token('space.075'),
	},
});

type ShowMoreButtonProps = {
	label: string;
	ariaLabel?: string;
	onClick: () => void;
	loading: boolean;
};

export function ShowMoreButton({
	label,
	ariaLabel,
	onClick,
	loading,
}: ShowMoreButtonProps): React.JSX.Element {
	return (
		<Pressable
			xcss={showMoreStyles.button}
			aria-label={
				expValEquals('a11y-fixes-week4-may-2026', 'isEnabled', true) ? ariaLabel : undefined
			}
			onClick={() => {
				if (!loading) onClick();
			}}
		>
			<Box as="span" xcss={showMoreStyles.showMoreLink}>
				{label}
				{loading && <Spinner size="small" />}
			</Box>
		</Pressable>
	);
}
